'use client';

// Libraries
import Head from 'next/head';
import { ReactElement } from 'react';
// Components
import { AuthBackground } from '@atoms/index';
import { RootLayout } from '@layout/index';
import { LoginCard } from '@organisms/index';
// Hooks
import { useAuthenticationRedirect } from '@hooks/index';
// Types
import { NextPageWithLayout } from '@globalTypes/index';

const Login: NextPageWithLayout = () => {
  useAuthenticationRedirect();

  return (
    <>
      <Head>
        <title>BearingAI - Login</title>
      </Head>
      <AuthBackground>
        <LoginCard />
      </AuthBackground>
    </>
  );
};

Login.getLayout = (page: ReactElement) => <RootLayout center>{page}</RootLayout>;

export default Login;
